import api from '@/api/subscriptions';

const productList = () => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.productList(apiLevel)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getExchangeRate = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  if (context.rootGetters['users/isKretaUser']) {
    resolve({ rates: [] });
  } else {
    api.getExchangeRate(apiLevel, data)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error);
        reject(error);
      });
  }
}));

const cancelSubscriptionFromBraintree = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.cancelSubscriptionFromBraintree(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const cancelSubscriptionForDkt = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.cancelSubscriptionForDkt(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const braintreeClientToken = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.braintreeClientToken(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const verifyBraintreePayment = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.verifyBraintreePayment(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getProduct = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.getProduct(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getBestPriceId = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.getBestPriceId(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const verifyCaptcha = (context, data) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.verifyCaptcha(apiLevel, data)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const rexProductList = () => new Promise(((resolve, reject) => {
  const apiLevel = 2;
  api.productList(apiLevel)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

const getSalesPosition = (context, payload) => new Promise(((resolve, reject) => {
  const apiLevel = 1;
  api.salesPosition(apiLevel, payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));

export default {
  cancelSubscriptionFromBraintree,
  braintreeClientToken,
  verifyBraintreePayment,
  productList,
  getProduct,
  getExchangeRate,
  cancelSubscriptionForDkt,
  getBestPriceId,
  verifyCaptcha,
  rexProductList,
  getSalesPosition,
};

